// API Client Config
import { ApiClientConfig } from 'Foundation/Api';
import { config } from '../config';

export const apiClientConfig: ApiClientConfig = {
  timeout: Number(config.defaultApi.requestTimeout) || 2000
};
